const d = () => {
  const e = {};
  return { on: (t, o) => {
    var n;
    return e[t] || (e[t] = /* @__PURE__ */ new Set()), (n = e[t]) == null || n.add(o), () => {
      var c;
      return (c = e[t]) == null ? void 0 : c.delete(o);
    };
  }, emit: (t, o) => {
    var n, c;
    (n = e[t]) == null || n.forEach((r) => r(o)), (c = e["*"]) == null || c.forEach((r) => r({ type: t, payload: o }));
  }, cleanup: () => {
    for (const t in e)
      delete e[t];
  } };
};
export {
  d as createEventEmitter
};
